import React from "react";
import { ArrowLongLeftIcon } from "@heroicons/react/24/outline";
import Button, { EButtonSize, EButtonstyletype, EButtonVariant } from "@Front/Components/DesignSystem/Button";
import { NextRouter, useRouter } from "next/router";
import { hardClientNavigate } from "@Front/Utils/hardClientNavigate";

type IProps = {
	url?: string;
	text?: string;
	onClick?: () => void;
	/**
	 * soft (default): Next router.push / router.back.
	 * hard: window.location.assign when url is set (remount target page under stable shell).
	 */
	navigationMode?: "soft" | "hard" | undefined;
};

type IPropsClass = IProps & {
	router: NextRouter;
};
type IState = Record<string, never>;
class BackArrowClass extends React.Component<IPropsClass, IState> {
	public constructor(props: IPropsClass) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	public override render(): React.JSX.Element {
		return (
			<Button
				leftIcon={<ArrowLongLeftIcon />}
				variant={EButtonVariant.PRIMARY}
				styletype={EButtonstyletype.TEXT}
				size={EButtonSize.SM}
				onClick={this.handleClick}>
				{this.props.text ?? "Retour"}
			</Button>
		);
	}

	private handleClick(): void {
		if (this.props.onClick) {
			this.props.onClick();
			return;
		}
		if (this.props.url) {
			if (this.props.navigationMode === "hard") {
				hardClientNavigate(this.props.url, "BackArrow");
				return;
			}
			void this.props.router.push(this.props.url);
			return;
		}
		this.props.router.back();
	}
}

export default function BackArrow(props: IProps): React.JSX.Element {
	const router = useRouter();
	return <BackArrowClass {...props} router={router} />;
}
